import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class Statement extends Component {
    constructor(props)
    {
        super(props);

        this.fetchStatement = this.fetchStatement.bind(this);
        this.generatePDF = this.generatePDF.bind(this);



        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            statement:[],
            server_response:"",
            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }


  generatePDF()
    {
      const input = document.getElementById('slip');

      html2canvas(input)
      .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          pdf.addImage(imgData, 'PNG', 0, 0);
          pdf.save("slip1.pdf");
        });

    }




  fetchStatement()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/student/feestatement";

            superagent
            .post(url)
            .send({admission_number:_this.props.student_details.core_details.AdmnNo})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                if(!error)
                {
                    console.log("Process", "successful loading");

                    _this.setState({statement:res.body.statement,server_response:res.body.message, loading:false, loaded_successfully:true, api_error_message:"",server_changes_made:true});

                }
                else
                {
                    _this.setState({loading:false, server_response:res.body.message, loaded_successfully:false, api_error_message:res.body.message, server_changes_made:true});
                }

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, server_response:err, loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && ! this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }



  renderDownloadButton()
  {
    const _this = this;

      if(this.state.statement.length > 0)
      {
          return(
                <button className="btn btn-primary btn-round" onClick={_this.generatePDF.bind(_this)} >Download<div className="ripple-container"></div></button>

          );
      }
      else{
          return null;
      }
  }



  renderStatement()
  {
    const _this = this;

    if(this.state.statement.length > 0 )
    {
      let block_list = this.state.statement.map(block =>
          {
          return (
              <div className = "col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h4 className = "term-header">{block.term}</h4>
                <table className = "full-width">

                  <thead className="text-s-header">
                      <tr>
                          <th>DATE</th>
                          <th>TYPE</th>
                          <th>REF</th>
                          <th>DESCRIPTION</th>
                          <th>DEBIT</th>
                          <th>CREDIT</th>
                          <th>BALANCE</th>
                      </tr>
                  </thead>

                <tbody>
                  {
                    block.transactions.map(trans => {
                      return(
                        <tr>
                          <td>{trans.dt.split("T")[0]}</td>
                          <td>{trans.typ}</td>
                          <td>{trans.ref}</td>
                          <td>{trans.description}</td>
                          <td>{trans.debit != null ? this.props.renderInThousands(trans.debit ): ""}</td>
                          <td>{trans.credit != null ? this.props.renderInThousands(trans.credit) : ""}</td>
                          <td>{this.props.renderInThousands(trans.balance)}</td>
                        </tr>
                      )
                    })
                  }

                  <tr>
                    <th >SUB TOTAL</th>
                    <td></td>
                    <td></td>
                    <td></td>
                    <th>{block.debit_total == 0 ? "" :this.props.renderInThousands(block.debit_total)}</th>
                    <th>{block.credit_Total == 0 ? "" :this.props.renderInThousands(block.credit_Total)}</th>
                    <td></td>
                  </tr>

                </tbody>

                </table>

                <hr/>
              </div>
                  );
          });

          return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">

              <h3 className = "text-center"> FEES STATEMENT</h3>

              <div style={{marginBottom:"15px"}} className ="row col-lg-12 col-md-12 full-width">
                  <span className = "col-lg-12 finance-titles"><span>NAME :</span><span className="comic academic-info">{"  " + _this.props.student_details.core_details.names} </span></span>
                  <span className = "col-lg-12 finance-titles"><span>Admission Number :</span><span className="comic academic-info">{"  " + _this.props.student_details.core_details.AdmnNo} </span></span>
                  <span className = "col-lg-12 finance-titles"><span>Programme: </span><span className="comic academic-info">{"  " + _this.props.student_details.class_details.programme}</span></span>
                 
              </div>

                {block_list}
            </div>
          );
    }
  else {
    return (<p> {_this.state.server_response}</p>)
  }


  }



  componentWillMount()
  {
    this.fetchStatement();
  }

  render() {

    const _this=this;

    let main_content;


    if(this.state.loading)
    {
        return(
            <div >
                    Loading Fees Statement, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="profile">
                                      <div className = "report-header" className ="row block-centered col-lg-12 col-md-12 full-width">
                                        <span className="col-lg-12 block-centered"><center><img src ="/img/logotuc.png" className="header-logo center"/> </center></span>
                                        <span className = "col-lg-12 center-align times-n header-name">TURKANA UNIVERSITY COLLEGE</span>
                                        <span className = "col-lg-12 center-align comic header-address">(CONSTITUENT COLLEGE OF MASINDE MULIRO UNIVERSITY OF SCIENCE AND TECHNOLOGY)</span>
                                        <span className = "col-lg-12 center-align comic header-address">P.O BOX 69-30500 LODWAR- KENYA</span>
                                      </div>


                                        {_this.renderStatement()}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default Statement;
